import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../components/shared/button";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";

const Verifycode = () => {
  const { t } = useTranslation();
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState("");
  const [otpArray, setOtpArray] = useState(new Array(6).fill(""));
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const { state } = location;
  const { userEmail } = state || {};

  useEffect(() => {
    if (userEmail) setEmail(userEmail);
  }, [userEmail]);

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_NODE_BASE_URL}/user/verify-resetcode`;

    const payload = {
      email: email,
      otp: otp,
    };

    try {
      console.log("inside api call", payload);

      const response = await axios.post(url, payload);
      if (response.status === 200) {
        toast.success("OTP verified successfully!");
        navigate("/new-password", {
          state: { email: email, otp: otp },
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "OTP verification failed");
    }
  };

  const handleInput = (e, index) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return;

    let updatedOtpArray = [...otpArray];
    updatedOtpArray[index] = value;
    setOtpArray(updatedOtpArray);
    setOtp(updatedOtpArray.join(""));

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !otpArray[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };
  return (
    <div className="flex flex-col lg:flex-row min-h-screen items-center max-md:gap-[60px] max-md:justify-start justify-center bg-lightwhite p-[20px]">
      {/* Left side*/}
      <div className="max-md:min-h-[10vh] max-md:border-none min-h-[80vh] border-solid border-r-2 border-r-gray-200 flex flex-col items-center justify-center w-full md:w-1/2 ">
        <img
          src="../../assets/images/dashboard/logo_large.png"
          alt="logo"
          className="w-100 h-100 max-md:w-[60px] max-md:h-[60px]"
        />
        <p className="text-blue font-bold text-[34px] max-md:text-[18px]">
          {t("verifycode.leftSide.title")}
        </p>
      </div>

      {/* Right side*/}
      <div className="flex flex-col items-center justify-center w-full md:w-1/2 ">
        <div className="w-full max-w-sm">
          <h4 className="small font-bold text-black">
            {t("verifycode.rightSide.title")}
          </h4>

          <form className="mt-[35px]" onSubmit={(e) => handleVerifyOTP(e)}>
            <label className="font-medium small">
              {t("verifycode.rightSide.enterCode")}
            </label>
            <div className="flex items-center gap-3 mt-[6px]">
              {[...Array(3)].map((_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="input-wrapper max-w-[50px] text-center w-full"
                  value={otpArray[index]}
                  onChange={(e) => handleInput(e, index)}
                  onKeyDown={(e) => handleBackspace(e, index)}
                  ref={(el) => (inputRefs.current[index] = el)}
                />
              ))}
              <span>-</span>
              {[...Array(3)].map((_, index) => (
                <input
                  key={index + 3}
                  type="text"
                  maxLength="1"
                  className="input-wrapper max-w-[50px] text-center w-full"
                  value={otpArray[index + 3]}
                  onChange={(e) => handleInput(e, index + 3)}
                  onKeyDown={(e) => handleBackspace(e, index + 3)}
                  ref={(el) => (inputRefs.current[index + 3] = el)}
                />
              ))}
            </div>
            <Button
              text={t("verifycode.rightSide.continue")}
              className="button btn-blue w-full mt-[38px]"
              height={50}
            ></Button>
          </form>
          {/* <p className="small flex justify-center gap-[4px] m-auto mt-[8px]">
            {t("verifycode.rightSide.noAccount")}
           <span onClick={() => navigate("/signup")} className="font-semibold"> 
              {t("verifycode.rightSide.signup")}
              </span>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Verifycode;
